
import { CaseDetails, CaseUser } from "@/types"
import { Component, Prop, Vue } from "vue-property-decorator"
import { CaseEvents } from "@/types/originatingEvents"
import { updateCaseDetails } from "@/scripts/caseDetails"
import { HubConnection } from "@aspnet/signalr"
import { RecordFieldsUpdateDto } from "@/types/caseUpdate"

@Component({})
export default class CaseHubEventHandler extends Vue {
	@Prop({ required: true }) private readonly currentCase!: CaseDetails | null

	protected render () {
		return null
	}

	public handleHubRecordEvents (connection: HubConnection) {
		connection.on("caseUpdated", (updatedCase: CaseDetails) => {
			if (this.currentCase) {
				updateCaseDetails(this.currentCase, updatedCase)
			}
		})
		connection.on("caseFieldsUpdated", (recordFieldsUpdateDto: RecordFieldsUpdateDto) => {
			this.$emit("caseFieldsUpdated", recordFieldsUpdateDto)
		})
		connection.on("viewingUsers", (viewingUsers: CaseUser[]) => {
			if (this.currentCase) {
				Vue.set(this.currentCase, "viewingUsers", viewingUsers)
				this.$emit("viewingUsers", viewingUsers)
			}
		})
		connection.on("caseEvents", (caseEvents: CaseEvents) => this.$emit("caseEvents", caseEvents))
		connection.on("caseNoLongerAvailable", () => {
			this.$emit("caseNoLongerAvailable")
		})
	}
}
